import * as React from 'react';
import createCache from '@emotion/cache';
import stylisRtl from 'stylis-plugin-rtl';
import { CacheProvider } from '@emotion/core';
import DirectionContext from './direction_context';
import propTypes from './prop_types';
import { jsx as ___EmotionJSX } from "@emotion/core";
var DirectionProvider = _ref => {
  var {
    children,
    direction = 'auto',
    locale = 'en-US'
  } = _ref;
  // document will be `undefined` when using SSR.
  var hasRtlTag = direction === 'auto' && typeof document !== 'undefined' && document.documentElement && document.documentElement.getAttribute('dir') === 'rtl';
  var isRTL = hasRtlTag || direction === 'rtl';
  var rtlCache = createCache({
    key: 'rtl',
    stylisPlugins: [stylisRtl]
  });
  var childrenRTL = ___EmotionJSX(CacheProvider, {
    value: rtlCache
  }, children);
  return ___EmotionJSX(DirectionContext.Provider, {
    value: {
      isRTL,
      locale
    }
  }, isRTL ? childrenRTL : children);
};
DirectionProvider.propTypes = propTypes;
export default DirectionProvider;